import { render, staticRenderFns } from "./UpdateRouting.vue?vue&type=template&id=42437a6b"
import script from "./UpdateRouting.vue?vue&type=script&lang=js"
export * from "./UpdateRouting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports